"use client";
import Image from "next/image";
import React from "react";
import { Images } from "@assets/assets";
import AudioPlayer from "@/components/AudioPlayer";
// import audioFile from '../../../public/audio/podcast1.mp3'
interface CareerHighlightCardProps {
  index: number | string;
  category: string;
  title: string;
  description: string;
  imageSrc: string;
  signSrc?: string;
  audio?: string;
  onPlayClick?: () => void;
}

export default function CareerHighlightCard({
  index,
  category,
  title,
  description,
  imageSrc,
  signSrc,
  audio,
}: CareerHighlightCardProps) {
  const indexLabel =
    typeof index === "number" ? String(index).padStart(2, "0") : index;
  return (
    <article className="group/card border border-[#ECF0F6] bg-white p-[30px] flex flex-col gap-6 max-w-[407px]">
      <div className="flex items-center gap-[15px]">
        <span className="text-[18px] leading-[140%] font-medium text-[#225BD4]">
          {indexLabel}
        </span>
        <span className="text-[18px] leading-[120%] clash-font text-[#00040b]">
          {category}
        </span>
        {signSrc ? (
          <Image
            src={signSrc}
            alt="sign"
            width={50}
            height={17}
            className="ml-auto"
            sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
          />
        ) : null}
      </div>

      <div className="w-full">
        <Image
          src={imageSrc}
          alt={title}
          width={323}
          height={291}
          className="w-full h-auto rounded-[4px] object-cover"
          sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
        />
      </div>

      <div className="flex flex-col gap-[15px]">
        <h3 className="text-[#00040b] clash-font font-medium leading-[120%] text-[28px] sm:text-[38px]">
          {title}
        </h3>
        <p className="text-[#636364] text-[18px] leading-[140%]">
          {description}
        </p>
      </div>

      <AudioPlayer
        audioSrc={audio as unknown as string}
        images={{
          play: Images?.career.podcast.play,
          pause: Images?.career.podcast.pause,
        }} // required: URLs or imported images compatible with next/image
        initialPlaying={false} // optional
      />
    </article>
  );
}
